import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Alert from "../../components/alert/alert";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";

export default function MyAccount() {
  const userReducer = useSelector((state) => state.userReducer);
  const getUserDetails = userReducer.currentUser;
  const bankDetailsReducer = useSelector((state) => state.bankDetailReducer);
  const getBankDetails = bankDetailsReducer
    ? bankDetailsReducer.bankDetails
    : "";

  const [alertMessage, setalertMessage] = useState({
    message: "Update your account details...",
    status: "warning",
    buttonStatus: true,
    routeName: "/profile",
  });
  const [depositSize, setdepositSize] = useState(0);
  const [totalPayout, settotalPayout] = useState(0);
  const [pandingPayout, setpandingPayout] = useState(0);
  const [rEmail, setrEmail] = useState(0);
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      firestore
        .collection("deposit")
        .where("userId", "==", user.uid)
        .get()
        .then((data) => {
          setdepositSize(data.size);
        });
      firestore
        .collection("paymentRequest")
        .where("userId", "==", user.uid)
        .get()
        .then((data) => {
          settotalPayout(data.size);
        });
      firestore
        .collection("paymentRequest")
        .where("userId", "==", user.uid)
        .where("status", "==", "pending")
        .get()
        .then((data) => {
          setpandingPayout(data.size);
        });
      firestore
        .collection("referrals")
        .where("rferralEmail", "==", user.email)

        .get()
        .then((data) => {
          setrEmail(data.size);
        });
    });
  }, []);
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>My Account </h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>My Account</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />
        <div class="account_wrapper float_left">
          <div class="row" style={{ marginBottom: "100px" }}>
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper">
                <h3>my account</h3>
                {
                  <div>
                    {getBankDetails ? (
                      ""
                    ) : (
                      <Alert details={{ ...alertMessage }} />
                    )}
                  </div>
                }
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-xl-3 col-sm-6 col-12">
              <div class="investment_box_wrapper color_1 float_left">
                <a href="#">
                  <div class="investment_icon_wrapper float_left">
                    <i class="far fa-money-bill-alt"></i>
                    <h1>Deposits</h1>
                  </div>

                  <div class="invest_details float_left">
                    <table class="invest_table">
                      <tbody>
                        <tr>
                          <td class="invest_td1">Paypal</td>
                          <td class="invest_td1">
                            :{" "}
                            {getBankDetails.payPalBalance
                              ? getBankDetails.payPalBalance
                              : "0.00"}{" "}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="invest_td1">Bitcoin</td>
                          <td class="invest_td1">
                            :{" "}
                            {getBankDetails.bitcoinBalance
                              ? getBankDetails.bitcoinBalance
                              : "0.00"}{" "}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="invest_td1">Transfer</td>
                          <td class="invest_td1">
                            :
                            {getBankDetails.cashDeposit
                              ? getBankDetails.cashDeposit
                              : "0.00"}{" "}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="invest_td1">Wire Transfer</td>
                          <td class="invest_td1">
                            :{" "}
                            {getBankDetails.wireTransfer
                              ? getBankDetails.wireTransfer
                              : "0.00"}{" "}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="invest_td1">Total Deposits</td>
                          <td class="invest_td1">: {depositSize}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 col-xl-3 col-sm-6 col-12">
              <div class="investment_box_wrapper color_2 float_left">
                <a href="#">
                  <div class="investment_icon_wrapper float_left">
                    <i class="far fa-money-bill-alt"></i>
                    <h1>payouts</h1>
                  </div>

                  <div class="invest_details float_left">
                    <table class="invest_table">
                      <tbody>
                        <tr>
                          <td class="invest_td1">total payouts</td>
                          <td class="invest_td1"> : {totalPayout}</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">pending payouts</td>
                          <td class="invest_td1">: {pandingPayout}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </a>
              </div>
            </div>
            {/* <div class="col-md-4 col-lg-4 col-xl-3 col-sm-6 col-12">
              <div class="investment_box_wrapper color_3 float_left">
                <a href="#">
                  <div class="investment_icon_wrapper float_left">
                    <i class="far fa-money-bill-alt"></i>
                    <h1>interest earn</h1>
                  </div>

                  <div class="invest_details float_left">
                    <table class="invest_table">
                      <tbody>
                        <tr>
                          <td class="invest_td1">interest today</td>
                          <td class="invest_td1"> : $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">interest this week</td>
                          <td class="invest_td1">: $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">interest this month</td>
                          <td class="invest_td1">: $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">interest earnings</td>
                          <td class="invest_td1">: $0.00 USD</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </a>
              </div>
            </div> */}
            {/* <div class="col-md-4 col-lg-4 col-xl-3 col-sm-6 col-12">
              <div class="investment_box_wrapper color_4 float_left">
                <a href="#">
                  <div class="investment_icon_wrapper float_left">
                    <i class="far fa-money-bill-alt"></i>
                    <h1>earnings</h1>
                  </div>

                  <div class="invest_details float_left">
                    <table class="invest_table">
                      <tbody>
                        <tr>
                          <td class="invest_td1">interest today</td>
                          <td class="invest_td1"> : $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">interest this week</td>
                          <td class="invest_td1">: $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">interest this month</td>
                          <td class="invest_td1">: $0.00 USD</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">total earnings</td>
                          <td class="invest_td1">: $192.00 USD</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </a>
              </div>
            </div> */}
            <div class="col-md-4 col-lg-4 col-xl-3 col-sm-6 col-12">
              <div class="investment_box_wrapper color_5 float_left">
                <a href="#">
                  <div class="investment_icon_wrapper float_left">
                    <i class="far fa-money-bill-alt"></i>
                    <h1>referral</h1>
                  </div>

                  <div class="invest_details float_left">
                    <table class="invest_table">
                      <tbody>
                        <tr>
                          <td class="invest_td1">Total referral</td>
                          <td class="invest_td1"> : {rEmail} nos</td>
                        </tr>
                        <tr>
                          <td class="invest_td1">Total profit</td>
                          <td class="invest_td1"> : {rEmail * 200} USD</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
}
